import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import {withAlert} from 'react-alert';
import {createUser, getUser} from "../auth/Auth";
import {putRequest, uploadFile} from "../routes/Routes";
import '../assets/css/Home.css';
import addImage from "../assets/images/add.png";

class AccountSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {user: null, action: '', passwordUnMatch: false};
        this.fileInput = React.createRef();
    }

    componentDidMount() {
        getUser(this.props.history).then(data => {
            this.setState({user: data});
        });
    }

    render() {
        let {user} = this.state;
        if (user) {
            return (
                <div className="container partner-list">
                    <div className="container">
                        <h1 className="brand-name">Account Settings</h1>
                        <hr/>
                        {this.state.action === 'password' ?
                            <div className="change-password-component">
                                <h3 className="form-heading">
                                    Update your Password
                                </h3>
                                <form onSubmit={this.formSubmit}>
                                    <div className="form-group">
                                        <input className="form-control" type="password"
                                               placeholder='Current Password' id="password" minLength="8" required/>
                                    </div>
                                    <div className="form-group">
                                        <input className="form-control" type="password"
                                               placeholder='New Password' id="newPassword" minLength="8" required/>
                                    </div>
                                    <div className="form-group">
                                        <input className="form-control" type="password"
                                               placeholder='Confirm New Password' id="confirmNewPassword" minLength="8"
                                               required/>
                                    </div>
                                    {this.state.passwordUnMatch &&
                                    <div className="alert alert-danger" role="alert">
                                        Passwords are not matching
                                    </div>}
                                    <NavLink to="/forgot-password">Forgot your password?</NavLink>
                                    <div className="form-buttons edit-account-buttons">
                                        <button type="submit" className="btn blue-button login-button">Confirm</button>
                                        <button className="btn blue-border-button login-button" id=""
                                                onClick={this.actionClick}>Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                            : this.state.action === 'profile' ?
                                this.editAccountRender() :
                                <table className="account-details">
                                    <tbody>
                                    <tr>
                                        <td>First Name</td>
                                        <td className="capital-text">{user.first_name}</td>
                                        <td className="action-column">
                                            <span id="profile" onClick={this.actionClick}>Edit Profile</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Last Name</td>
                                        <td className="capital-text">{user.last_name}</td>
                                    </tr>
                                    <tr>
                                        <td>Email Address</td>
                                        <td>{user.email}</td>
                                    </tr>
                                    <tr>
                                        <td>Address</td>
                                        <td>{user.address}</td>
                                    </tr>
                                    <tr>
                                        <td>City</td>
                                        <td>{user.city}</td>
                                    </tr>
                                    <tr>
                                        <td>Phone</td>
                                        <td>{user.phone}</td>
                                    </tr>
                                    <tr>
                                        <td>Password</td>
                                        <td>********</td>
                                        <td className="action-column">
                                            <span id="password" onClick={this.actionClick}>Change Password</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                        }
                        {user.role_id === 2 ?
                            <div className="store-setting-container">
                                <h1 className="brand-name">Store Settings</h1>
                                <hr/>
                                {this.state.action === 'store' ?
                                    this.editStoreRender() :
                                    <table className="account-details">
                                        <tbody>
                                        <tr>
                                            <td>Store Name</td>
                                            <td className="capital-text">{user.partner.name}</td>
                                            <td className="action-column">
                                                <span id="store" onClick={this.actionClick}>Edit Store</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Store Image</td>
                                            <td>
                                                <img src={user.partner.image_url} alt={user.partner.name}
                                                     className="store-image"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Store Email Address</td>
                                            <td>{user.partner.email}</td>
                                        </tr>
                                        <tr>
                                            <td>Store Address</td>
                                            <td>{user.partner.address}</td>
                                        </tr>
                                        <tr>
                                            <td>Store City</td>
                                            <td>{user.partner.city}</td>
                                        </tr>
                                        <tr>
                                            <td>Store Phone</td>
                                            <td>{user.partner.phone}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                }
                            </div>
                            : null
                        }
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    actionClick = (event) => {
        event.preventDefault();
        this.setState({action: event.target.id});
    };

    formSubmit = (event) => {
        event.preventDefault();
        if (this.state.action === 'profile') {
            let values = {
                first_name: event.target.firstName.value,
                last_name: event.target.lastName.value,
                email: event.target.email.value,
                address: event.target.address.value,
                city: event.target.city.value,
                phone: event.target.phone.value,
                endpoint: '/api/users',
                token: this.state.user.api_token
            };
            putRequest(values).then(response => {
                if (response.status === 200) {
                    if (response.data.error) {
                        this.props.alert.error(response.data.message);
                    } else {
                        createUser(response.data.user).then(() => {
                            this.setState({action: '', user: response.data.user});
                            this.props.alert.success("Successfully Updated Account");
                        });
                    }
                } else {
                    this.props.alert.error(response.data.message);
                }
            });
        } else if (this.state.action === 'password') {
            const newPassword = event.target.newPassword.value;
            const confirmNewPassword = event.target.confirmNewPassword.value;
            if (newPassword !== confirmNewPassword) {
                this.setState({passwordUnMatch: true});
            } else {
                this.setState({passwordUnMatch: false});
                let values = {
                    oldPassword: event.target.password.value,
                    newPassword: newPassword,
                    email: this.state.user.email,
                    endpoint: '/api/users/update-password',
                    token: this.state.user.api_token
                };
                putRequest(values).then(response => {
                    if (response.status === 200) {
                        if (response.data.error) {
                            this.props.alert.error(response.data.message);
                        } else {
                            this.setState({action: ''});
                            this.props.alert.success("Successfully Updated Password");
                        }
                    } else {
                        this.props.alert.error(response.data.message);
                    }
                });
            }
        } else if (this.state.action === 'store') {
            const data = new FormData();
            data.append('name', event.target.storeName.value);
            data.append('email', event.target.storeEmail.value);
            data.append('address', event.target.storeAddress.value);
            data.append('city', event.target.storeCity.value);
            data.append('phone', event.target.storePhone.value);
            data.append('id', this.state.user.partner ? this.state.user.partner.id : null);
            data.append('user_id', this.state.user.id);
            if (this.fileInput.current.files.length > 0) {
                data.append('image', this.fileInput.current.files[0]);
            }
            uploadFile(data, '/api/partners', this.state.user.api_token).then(async response => {
                if (response.status === 200) {
                    if (response.data.error) {
                        this.props.alert.error(response.data.message);
                    } else {
                        let user = this.state.user;
                        user.partner = response.data.partner;
                        createUser(user).then(() => {
                            this.setState({action: '', user: user});
                            this.props.alert.success("Successfully Updated Store");
                        });
                    }
                } else {
                    this.props.alert.error(response.data.message);
                }
            });
        }
    };

    editAccountRender = () => {
        const inputArray = [
            {
                type: 'text',
                label: 'First Name*',
                placeholder: 'First Name',
                id: 'firstName',
                value: this.state.user.first_name,
                required: true,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'text',
                label: 'Last Name*',
                placeholder: 'Last Name',
                id: 'lastName',
                value: this.state.user.last_name,
                required: true,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'email',
                label: 'Email*',
                placeholder: 'Email',
                id: 'email',
                value: this.state.user.email,
                required: true,
                pattern: '',
                help: '',
                disabled: true
            },
            {
                type: 'text',
                label: 'Address',
                placeholder: 'Address',
                id: 'address',
                value: this.state.user.address,
                required: false,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'text',
                label: 'City',
                placeholder: 'City',
                id: 'city',
                value: this.state.user.city,
                required: false,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'tel',
                label: 'Phone',
                placeholder: 'Phone',
                id: 'phone',
                value: this.state.user.phone,
                required: false,
                pattern: '[0-9]{10}',
                help: 'Please follow the pattern (0771234567)',
                disabled: false,
                css: 'final-input'
            },
        ];

        return this.getFormBody(inputArray);
    };

    getFormInputs = (input) => {
        if (input.type === 'image') {
            return (
                <div className="custom-file">
                    <input type="file" className="custom-file-input" id="image" accept="image/*"
                           ref={this.fileInput}/>
                    <label className="custom-file-label" htmlFor="image">
                        <img src={addImage} alt="Add Image Icon"/>
                        <div className="image-uploader-label">
                            Drag & drop or <span className="blue-font">select from your files</span>
                        </div>
                    </label>
                    <small id="image" className="form-text text-muted">
                        Add Store Image
                    </small>
                </div>
            );
        } else {
            return (
                <div className={"p-2 flex-fill bd-highlight edit-account-input " + input.css}>
                    <div className="form-group">
                        <label htmlFor={input.id}>{input.label}</label>
                        <input className="form-control" type={input.type}
                               placeholder={input.placeholder} id={input.id}
                               defaultValue={input.value} required={input.required}
                               disabled={input.disabled}
                               pattern={input.pattern !== '' ? input.pattern : null}/>
                        {input.help !== '' ?
                            <small id={input.id}
                                   className="form-text text-muted">{input.help}</small>
                            : null
                        }
                    </div>
                </div>
            );
        }
    };

    getFormBody = (inputArray) => {
        let formBody = [];
        for (let i = 0; i < inputArray.length; i++) {
            formBody.push(
                <div className="d-flex bd-highlight w-100" key={i}>
                    {this.getFormInputs(inputArray[i])}
                    {!isMobile && ++i < inputArray.length ?
                        this.getFormInputs(inputArray[i])
                        : null
                    }
                </div>
            )
        }
        return (
            <div>
                <h3 className="form-heading">
                    Edit your {this.state.action}
                </h3>
                <form onSubmit={this.formSubmit}>
                    {formBody}
                    <div className="form-buttons edit-account-buttons">
                        <button type="submit" className="btn blue-button login-button">Confirm</button>
                        <button className="btn blue-border-button login-button" id=""
                                onClick={this.actionClick}>Cancel
                        </button>
                    </div>
                </form>
            </div>
        );
    };

    editStoreRender = () => {
        const inputArray = [
            {
                type: 'text',
                label: 'Store Name*',
                placeholder: 'Store Name',
                id: 'storeName',
                value: this.state.user.partner.name,
                required: true,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'email',
                label: 'Store Email Address*',
                placeholder: 'Store Email Address',
                id: 'storeEmail',
                value: this.state.user.partner.email,
                required: true,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'text',
                label: 'Store Address',
                placeholder: 'Store Address',
                id: 'storeAddress',
                value: this.state.user.partner.address,
                required: false,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'text',
                label: 'Store City',
                placeholder: 'Store City',
                id: 'storeCity',
                value: this.state.user.partner.city,
                required: false,
                pattern: '',
                help: '',
                disabled: false
            },
            {
                type: 'tel',
                label: 'Store Phone',
                placeholder: 'Store Phone',
                id: 'storePhone',
                value: this.state.user.partner.phone,
                required: false,
                pattern: '[0-9]{10}',
                help: 'Please follow the pattern (0771234567)',
                disabled: false
            },
            {
                type: 'number',
                label: 'Commission',
                placeholder: 'Commission',
                id: 'commission',
                value: this.state.user.partner.commission,
                required: false,
                help: 'Commission Percentage (%)',
                disabled: true,
                css: 'final-input'
            },
            {type: 'image'}
        ];

        return this.getFormBody(inputArray);
    };
}

export default withAlert()(withRouter(AccountSettings));
